<template>
  <!-- Product search -->
  <el-dialog
    title="Бүтээгдэхүүн сонгох"
    :visible.sync="show"
    @close="closeDialog"
    width="50%"
  >
    <div>
      <el-input
        placeholder="Барааны нэр, SKU ..."
        v-model="searchText"
        @input="searchProduct"
      >
        <el-button slot="append" icon="el-icon-search" @click="searchProduct"></el-button>
      </el-input>
    </div>
    <div class="mt20" v-loading="productLoading">
      <ul class="transfer-product-list" v-if="products.length > 0">
        <li v-for="(product, index) in products" :key="index">
          <el-row :gutter="10" type="flex" align="middle">
            <el-col :span="5">
              <el-carousel :interval="4000" indicator-position="outside" height="80px">
                <el-carousel-item v-for="(item, index) in product.image" :key="index">
                  <img :src="item" alt="" class="item__image">
                </el-carousel-item>
              </el-carousel>
            </el-col>
            <el-col :span="19">
              {{product.name_mon}}
            </el-col>
            <el-col :span="2" class="text-right">
              <el-checkbox v-model="product.checked" :indeterminate="product.isIndeterminate" @change="checkProduct(product)"></el-checkbox>
            </el-col>
          </el-row>
          <ul>
            <li v-for="(variant, index) in product.variants" :key="index">
              <el-row :gutter="20" type="flex" align="middle">
                <el-col :span="14" :offset="2">
                  <div>
                    {{variant.variant_name}}
                  </div>
                  <div class="text-color-secondary">
                    {{variant.variant_sku}}
                  </div>
                </el-col>
                <el-col :span="4">
                  {{variant.variant_sellPrice}}₮
                </el-col>
                <el-col :span="2">
                  <div class="text-center">
                    {{variant.count}} ш
                  </div>
                </el-col>
                <el-col :span="2" class="text-right">
                  <el-checkbox v-model="variant.checked" @change="checkVariant(product, variant)"></el-checkbox>
                </el-col>
              </el-row>
            </li>
          </ul>
        </li>
      </ul>
      <div v-else class="text-center mtb30">
        <div class="text-color-placeholder">
          <p>
            Бараа байхгүй байна
          </p>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false">Cancel</el-button>
      <el-button type="success" @click="returnProducts">
        Бүтээгдэхүүн нэмэх
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import services from '../../../helpers/services'
export default {
  name: 'productSearchDialog',
  props: {
    visibleProductDialog: {
      type: Boolean,
      default: false
    },
    mergeProduct: {
      type: Function,
      default: () => null
    }
  },
  data () {
    return {
      searchText: '',
      products: [],
      productLoading: false,
      show: this.visibleProductDialog
    }
  },
  mounted () {
    this.searchProduct()
  },
  methods: {
    closeDialog () {
      this.$emit('update:visibleProductDialog', false)
    },
    checkProduct (product) {
      product.variants.forEach(variant => {
        variant.checked = product.checked
      })
    },
    checkVariant (product, variant) {
      let checkedCount = 0
      product.variants.forEach(variant => {
        if (variant.checked) {
          checkedCount = checkedCount + 1
        }
      })
      product.checked = checkedCount === product.variants.length
      product.isIndeterminate = checkedCount > 0 && checkedCount < product.variants.length
    },
    searchProduct () {
      this.productLoading = true
      this.visibleProductDialog = true
      services.getProducts('?search_text=' + this.searchText).then(response => {
        if (Array.isArray(response.datas) && response.datas.length > 0) {
          this.products = response.datas
        }
        this.productLoading = false
      })
    },
    returnProducts () {
      const tempProducts = []
      let variants = null
      this.products.forEach(product => {
        if (Object.prototype.hasOwnProperty.call(product, 'variants')) {
          variants = [...product.variants.filter(variant => variant.checked)]
        }
        if (variants.length > 0) {
          product.variants = variants
          tempProducts.push(product)
        }
      })
      if (tempProducts.length > 0) {
        this.$emit('update:products', tempProducts)
        this.mergeProduct()
        this.show = false
      } else {
        this.$notify.error({
          title: 'Oops',
          position: 'bottom-left',
          message: 'Бүтээгдэхүүн сонгоно уу',
          duration: 2000
        })
      }
    }
  }
}
</script>
